/**
 * Phase 101bs (16/02/2026) — Calcul pur de la fraîcheur d'un snapshot MOMA.
 *
 * Extrait dans un fichier séparé pour être testé unitairement sans importer
 * la stack React + api.js (qui crashe en env Jest sans BACKEND_URL).
 *
 * @param {string|Date|null|undefined} iso — timestamp du snapshot (ISO ou Date)
 * @param {number} now — timestamp actuel en ms (par défaut Date.now())
 * @returns {{label: string, tone: "fresh"|"warm"|"stale"} | null}
 *   - fresh (< 30 min) : vert
 *   - warm (30 min – 2 h) : ambre
 *   - stale (≥ 2 h) : rouge
 *   Retourne null si iso invalide (pas de badge affiché).
 */
export function computeSnapshotFreshness(iso, now = Date.now()) {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (isNaN(t)) return null;
  const ageMs = Math.max(0, now - t);
  const ageMin = Math.floor(ageMs / 60_000);
  const ageHr = Math.floor(ageMs / 3_600_000);
  const ageDay = Math.floor(ageMs / 86_400_000);

  let label;
  if (ageDay >= 1) label = `il y a ${ageDay} j`;
  else if (ageHr >= 1) label = `il y a ${ageHr} h`;
  else if (ageMin >= 1) label = `il y a ${ageMin} min`;
  else label = "à l'instant";

  let tone;
  if (ageMin < 30) tone = "fresh";
  else if (ageHr < 2) tone = "warm";
  else tone = "stale";

  return { label, tone };
}
